import React, { Component } from 'react'
import EkoModal from '../../components/elements/EkoModal'
import { EkoFormInputText, EkoFormButton, EkoFormSwitch } from '../../components/elements/EkoForm'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Api from "../../util/Api";
import { toastr } from "react-redux-toastr";

class AskCollection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true,
            saving: false,
            savingModal: false,
            copied: false,
            active: false,
            linkName: "TAHSİLAT LİNKİNİ GÖNDER",
            buttonDisabled: false,
            switchValueCommission: true,
            switchValueInstallment: true,
            vposList: [],
            bankPairList: [],
            invoiceLink: null,
            customerPhoneNumber: "",
            customerEmail: "",
        }
    }

    componentDidMount() {
        this.getFlexOdemeVposList();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.showModal && this.props.showModal) {
            this.getSalesInvoiceCustomerData();
        }
    }

    closeModal() {
        this.setState({ active: false, buttonDisabled: false, linkName: "TAHSİLAT LİNKİNİ GÖNDER", saving: false, formData: {} });
        this.props.closeModal();
    }

    onMount() {
    }

    onClick() {
        this.setState({ active: true, buttonDisabled: true, linkName: "LÜTFEN BEKLEYİNİZ" });
    }

    tgl(link, switchStatus) {
        this.setState({ switchValueCommission: switchStatus });
        var linkParam = link.split('/').pop();
        Api.get("/paynet/setPaynetTransaction/commission/" + linkParam + "/" + switchStatus, (response, err) => {
            if (err) {
                toastr.error("Hata!", "Sistemsel Bir Sorun Oluştu");
            } else {
                toastr.info("Başarılı!", "Komisyon Bilgileri Güncellendi");
            }
        });
    }

    tgl2(link, switchStatus) {
        this.setState({ switchValueInstallment: switchStatus });
        var linkParam = link.split('/').pop();
        Api.get("/paynet/setPaynetTransaction/installment/" + linkParam + "/" + switchStatus, (response, err) => {
            if (err) {
                toastr.error("Hata!", "Sistemsel Bir Sorun Oluştu");
            } else {
                toastr.info("Başarılı!", "Taksit Bilgileri Güncellendi");
            }
        });
    }

    getFlexOdemeVposList = async () => {
        Api.get("/getCompanyFlexOdemeVposList", (response, errors) => {
            if (errors) {
                toastr.error("Sayfa yüklenirken hata oluştu. Lütfen tekrar deneyiniz.");
                return;
            }
            if (response.result == "1") {
                this.setState({ vposList: response.data, bankPairList: response.bank_account_pair_data });
            }
        });
    }
    getSalesInvoiceCustomerData = async () => {
        if (!this.props.salesInvoiceId || this.props.salesInvoiceId === 0 || this.props.salesInvoiceId === "") {
            return;
        }
        Api.post("/getSalesInvoiceCustomerData", { salesInvoiceId: this.props.salesInvoiceId }, (response, err) => {
            if (err) {
                toastr.error("Hata", "Satış faturası müşteri bilgileri alınamadı");
            } else {
                if (response.result == "1") {
                    this.setState({
                        customerPhoneNumber: response.phone,
                        customerEmail: response.email,
                    });
                }
                else{
                    toastr.error("Hata", response.message);
                }
            }
        });
    }

    handleSendSalesInvoiceLink = () => {
        this.setState({ buttonDisabled: true, linkName: "LÜTFEN BEKLEYİNİZ" });
        Api.post("/createFlexOdemeSalesInvoiceLink",
            {
                salesInvoiceId: this.props.salesInvoiceId,
                phoneNumber: this.state.customerPhoneNumber,
                email: this.state.customerEmail,
            }, (response, err) => {
                this.setState({ buttonDisabled: false, linkName: "TAHSİLAT LİNKİNİ GÖNDER" });
                if (err) {
                    toastr.error("Hata", "Tahsilat linki gönderilemedi");
                } else {
                    if (response.result == "1") {
                        toastr.success("Başarılı", "Tahsilat linki gönderildi");
                        this.setState({invoiceLink: response.link});
                    }
                    else{
                        toastr.error("Hata", response.message);
                    }
                }
            });
    };

    render() {
        const paynet_status = JSON.parse(localStorage.getItem("paynetStatus"));
        return (
            <EkoModal
                showModal={this.props.showModal}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.savingModal}
                title={"Ödeme Linki Oluştur"}
            >
                <div className="row">
                    {/* FLEXÖDE.ME Bölümü */}
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h3>FlexOde.me Tahsilat Sistemi</h3>
                            </div>
                            <div className="panel-body">
                                {this.state.bankPairList.length === 0 ? (
                                    <div className="row">
                                        <div className="col-md-12" style={{ height: "100px" }}>
                                            FlexÖde.me Modülü Aktif Değil veya Banka Hesap Eşleşmesi Yapılmamış.<br /><br />
                                            <a href="/dashboard/integrations" className="btn blue" target="_blank">
                                                Modül Ayarları İçin Tıklayın
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p>
                                                Seçtiğiniz satış faturası bilgileri baz alınarak tahsilat linki oluşturulacak.
                                            </p>
                                            <div className="form-group">
                                                <label><strong>Telefon Numarası</strong> (Başında 0 olmadan giriniz.)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder=""
                                                    value={this.state.customerPhoneNumber}
                                                    onChange={(e) => this.setState({ customerPhoneNumber: e.target.value })}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label><strong>E-Posta Adresi</strong> (Geçerli e-posta adresi giriniz.)</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder=""
                                                    value={this.state.customerEmail}
                                                    onChange={(e) => this.setState({ customerEmail: e.target.value })}
                                                />
                                            </div>
                                            <EkoFormButton
                                                label={"OLUŞTUR VE GÖNDER"}
                                                className="btn blue"
                                                onClick={this.handleSendSalesInvoiceLink.bind(this)}
                                                disabled={this.state.buttonDisabled}
                                            />
                                            {this.state.invoiceLink && (
                                                <div style={{ marginTop: "20px" }}>
                                                    <p style={{ fontWeight: "bold" }}>
                                                        Oluşturulan tahsilat linki: <span style={{ wordBreak: "break-word" }}>{this.state.invoiceLink}</span>
                                                    </p>
                                                    <div className="d-flex align-items-center gap-2" style={{ marginBottom: "10px" }}>
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-success btn-sm"
                                                            href={`https://api.whatsapp.com/send?text=Oluşturulan faturanız için ödeme linkiniz: ${encodeURIComponent(this.state.invoiceLink)}`}
                                                        >
                                                            <i className="fab fa-whatsapp" style={{ color: "white", fontSize: "16px" }}></i> Whatsapp ile gönder
                                                        </a>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    </div>

                    {/* PAYNET Bölümü */}
                    <div className="col-md-12">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                                <h3>PAYNET</h3>
                            </div>
                            <div className="panel-body">
                                {paynet_status === 0 ? (
                                    <div className="row">
                                        <div className="col-md-12" style={{ height: "100px" }}>
                                            Paynet Üyesi Olmadığınız İçin Bu Hizmetten Yararlanamıyorsunuz. Kayıt Olmak İçin Aşağıdaki Linke Tıklayınız <br /><br />
                                            <a href="https://basvuru.paynet.com.tr/basvuru-formu" className="enrollLink" target="_blank">Kayıt İşlemi İçin Tıklayınız</a>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row">
                                        <div className="col-md-12">
                                            Ödeme Aracı Kurum Komisyonunu Kimin Ödeyeceğini Seçiniz
                                            <EkoFormSwitch
                                                leftBox={false}
                                                md={12}
                                                textOn="Komisyonu Ben Ödeyeceğim"
                                                textOff="Karşı Taraf Ödeyecek"
                                                onChange={(newSwitchStatus) => this.tgl(this.props.link, newSwitchStatus)}
                                                value={this.state.switchValueCommission}
                                            />
                                        </div>
                                        <div className="col-md-12" style={{ marginTop: "20px" }}>
                                            Ödeme Aracı Kurum Bu Ödeme İçin Taksit Seçeneği Sunsun Mu?
                                            <EkoFormSwitch
                                                leftBox={false}
                                                md={12}
                                                textOn="Evet"
                                                textOff="Hayır"
                                                onChange={(newSwitchStatus) => this.tgl2(this.props.link, newSwitchStatus)}
                                                value={this.state.switchValueInstallment}
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <EkoFormInputText
                                                id="paynet"
                                                onMount={this.onMount}
                                                disabled
                                                type="text"
                                                value={this.props.link}
                                                style={{ paddingLeft: "15px" }}
                                                label="Aşağıdaki Linki Kopyalayarak Müşterinize İletebilirsiniz"
                                                isVertical={true} />
                                        </div>
                                        <div className="col-md-4">
                                            <CopyToClipboard text={this.props.link}
                                                             onCopy={() => this.setState({ copied: true })}>
                                                <EkoFormButton label="Kopyala"
                                                               className={'btn blue pull-right'}
                                                               onClick={this.onClick.bind(this)}
                                                               disabled={this.state.buttonDisabled}
                                                />
                                            </CopyToClipboard>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </EkoModal>
        )
    }
}

export default AskCollection;
